// extracted by mini-css-extract-plugin
export var closeButton = "_m2-1";
export var closeX = "_m2-3";
export var container = "_m2-0";
export var image = "_m2-2";